"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.radarPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var radarPalette = {
  radar10: '#FAE0E1',
  radar30: '#FAC6C7',
  radar60: '#FB9493',
  radar: '#E45853',
  radarDark: '#D7303B',
  radarDarkest: '#B51F1A'
};
exports.radarPalette = radarPalette;